import {
  defineNotificationWorkflow,
  notificationWorkflowKeyFromEnum,
} from '@app/modules/notifications/workflows/notification-workflow';
import { NotificationsEvidenceExportCompletedNotificationDtoWorkflowKeyEnum } from '@mi-front/api-v2';
import { defineMessage } from 'react-intl';

function isHttpUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

const downloadMessage = defineMessage({
  id: 'notifications.item.download',
  defaultMessage: 'Descargar',
});

/**
 * Knock workflow: report evidence export finished.
 * No row navigate — offers a download action when `storageUri` is an http(s) URL.
 */
export const evidenceExportCompletedWorkflow = defineNotificationWorkflow({
  key: notificationWorkflowKeyFromEnum(
    NotificationsEvidenceExportCompletedNotificationDtoWorkflowKeyEnum,
  ),
  category: 'audit',
  channels: { inApp: true, email: false },
  severity: 'success',
  toast: true,
  preference: {
    title: defineMessage({
      id: 'notifications.preferences.workflow.evidenceExportCompleted.title',
      defaultMessage: 'Evidencias listas para descargar',
    }),
    description: defineMessage({
      id: 'notifications.preferences.workflow.evidenceExportCompleted.description',
      defaultMessage: 'Cuando el paquete de evidencias de un informe está listo',
    }),
  },
  actionUrl: () => null,
  actions: (data) => {
    if (!isHttpUrl(data.storageUri)) {
      return [];
    }
    return [
      {
        name: 'download',
        label: downloadMessage,
        url: data.storageUri,
      },
    ];
  },
});
